module.exports = __webpack_public_path__ + "img/love_potion_chocolate_box.cde4ffd2.jpg";